import { render } from "./TransportModeForm.vue?vue&type=template&id=547d747c&ts=true"
import script from "./TransportModeForm.vue?vue&type=script&lang=ts"
export * from "./TransportModeForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__